import { useState as r } from "react";
import t from "prop-types";
import { createPortal as n } from "react-dom";
import { useIsomorphicLayoutEffect as e } from "@leafygreen-ui/hooks";

function o(r, t) {
  return function (r) {
    if (Array.isArray(r)) return r;
  }(r) || function (r, t) {
    var n = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null == n) return;
    var e,
        o,
        a = [],
        i = !0,
        l = !1;

    try {
      for (n = n.call(r); !(i = (e = n.next()).done) && (a.push(e.value), !t || a.length !== t); i = !0) {
        ;
      }
    } catch (r) {
      l = !0, o = r;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (l) throw o;
      }
    }

    return a;
  }(r, t) || function (r, t) {
    if (!r) return;
    if ("string" == typeof r) return a(r, t);
    var n = Object.prototype.toString.call(r).slice(8, -1);
    "Object" === n && r.constructor && (n = r.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(r);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a(r, t);
  }(r, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function a(r, t) {
  (null == t || t > r.length) && (t = r.length);

  for (var n = 0, e = new Array(t); n < t; n++) {
    e[n] = r[n];
  }

  return e;
}

function i(t) {
  var a,
      i = function (t) {
    var n = o(r(), 2),
        a = n[0],
        i = n[1];
    return e(function () {
      if (!t) {
        var r = document.createElement("div");
        return document.body.appendChild(r), i(r), function () {
          r.remove();
        };
      }

      i(t);
    }, [t]), a;
  }(null !== (a = t.container) && void 0 !== a ? a : void 0);

  return e(function () {
    var r;
    i && !t.container && (i.className = null !== (r = t.className) && void 0 !== r ? r : "");
  }, [i, t.container, t.className]), i ? n(t.children, i) : null;
}

i.displayName = "Portal", i.propTypes = {
  children: t.node,
  className: t.string,
  container: t.oneOfType([t.node, t.object])
};
export { i as default };